import { useParams } from "react-router-dom";
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { show_alerta } from '../../funciones.js';
import { useNavigate } from "react-router-dom";

import CONFIG from '../../config';
import PerfilInfo from "./PerfilInfo";
import FichaUsuarioRolInfo from "./FichaUsuarioRolInfo";
import PerfilForm from "./PerfilForm";
import './css/fichaUsuario.css';
import TutorCrudForm from "./TutorCrudForm.js";
import { ButtonToolbar } from "react-bootstrap";

const URL_LISTAR = `${CONFIG.API_URL}/listarUsuarios.php`;
const URL  = `${CONFIG.API_URL}/operarTablaUsuario.php`;

function FichaUsuario({ configuracion, acceder, rol, vista }) {
    const { usuarioId } = useParams();
    const defaultFilePerfil = 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png';
    const [perfil, setPerfil] = useState({
        id: null,
        nombre: "",
        apellido: "",
        apodo: "",
        imagen_perfil: "",
        fecnac: "",
        email: "",
        genero: "",
        telefono: "",
        calle: "",
        numero: "",
        piso: "",
        depto: "",
        ciudad: "",
        provincia: ""
    });
    const [tutores, setTutores] = useState([]);
    const [roles, setRoles] = useState([]);
    const [activeIndex, setActiveIndex] = useState(null); // Estado para el índice activo
    const [mostrarEditar, setMostrarEditar] = useState(false);
    const [mostrarFormulafio, setMostrarFormulario] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if(acceder){
            if((rol===null)){
                navigate("/");
            }
        }else{
            localStorage.clear();
            navigate("/");
        }
        obtenerDatos();
    }, [usuarioId]);

    // Establecer el primer rol como activo por defecto
    useEffect(() => {
        if (roles.length > 0) {
            setActiveIndex(roles[0].id);
        }
    }, [roles]);

    const obtenerDatos = async () => {
        const data = {
            'id_usuario': usuarioId,
            'modo': 'buscarFichalUsuario'
        };
        
        try {
            const res = await axios.post(URL_LISTAR, data);
            if (!res.data.error) {
                setPerfil(res.data.info);
                setRoles(res.data.roles);
                setTutores(res.data.tutores);
            } else {
                setPerfil(null);
                setRoles([]);
                setTutores([]);
            }
        } catch (err) {
            console.error(err);
        } 
    };
    const actualizarData = (data) =>{
        //console.log("dataaaaa: "+data);
        enviarSolicitud("POST", data);
    };

    const enviarSolicitud = async (metodo, parametros) =>{
        await axios({method:metodo, url:URL, data:parametros})
            .then(res =>{
                var tipo = res.data[0];
                var msj = res.data[1];
                //console.log(res);
                //var sql = res.data[2];
                //console.log(tipo + "-" + msj+'-'+sql);
                setMostrarEditar(false);
                setPerfil(perfil);
                obtenerDatos();
                show_alerta(msj,tipo);
            })
            .catch(err=>{
                show_alerta('Error en la solicitud ','error');
                console.log(err);
            })
    }

    const previewFoto=(e)=>{
        //console.log(e.target.files[0]);
        let img= document.getElementById('imagen');
        if( e.target.files[0] ){
            const reader = new FileReader( );
            reader.onload = function( e ){
                img.src = e.target.result;
            }
            reader.readAsDataURL(e.target.files[0])
        }else{
            img.src = defaultFilePerfil;
        }
    }

    const obtenerEdad = (dateString) => {
        let hoy = new Date();
        let fechaNacimiento = new Date(dateString);
        let edad = hoy.getFullYear() - fechaNacimiento.getFullYear();
        let diferenciaMeses = hoy.getMonth() - fechaNacimiento.getMonth();
        if (diferenciaMeses < 0 || (diferenciaMeses === 0 && hoy.getDate() < fechaNacimiento.getDate())) {
            edad--;
        }
        return edad;
    };

    const obtenerIniciales = (nombre, apellido) => {
        const n = nombre ? nombre.charAt(0).toUpperCase() : "";
        const a = apellido ? apellido.charAt(0).toUpperCase() : "";
        return n + a;
    };

       const generarColor = (texto) => {
        const colores = ["#0d6efd", "#198754", "#dc3545", "#fd7e14", "#6f42c1"];
        let index = texto ? texto.charCodeAt(0) % colores.length : 0;
        return colores[index];
    };

    return (
    <div className='container-principal'>
        <div className="contenedor-datos">
            <div className="row">
                <div className="col-12 col-sm-6"> 
                    <div className='avatar-wrapper'>

                        {(perfil.imagen_perfil && perfil.imagen_perfil !== '') ? (
                            <img className="imagen-circular-estudiante"
                            src={`${CONFIG.API_URL}/${perfil.imagen_perfil}`} 
                            />
                        ) : (
                            <div 
                            className="imagen-circular-estudiante"
                            style={{ backgroundColor: generarColor(perfil.nombre) }}
                            >
                            {obtenerIniciales(perfil.nombre, perfil.apellido)}
                            </div>
                        )}
                        {/* LOGO */}
                        <img 
                            src={`${process.env.PUBLIC_URL}/img/${configuracion.logo_solo}`}
                            className="logo-inferior"
                        />
                        
                    </div>  
                    <div className="row">
                        <div className="col-12 col-sm-6 mt-4">
                            <h4 className='card-nombre text-black'>{perfil.nombre} {perfil.apellido} </h4>
                            <div className="text-secondary">Doc. N°: {perfil.documento}</div>
                            <div className='card-apodo'>{perfil.apodo} {perfil.fecnac?`(${obtenerEdad(perfil.fecnac)})`:''}</div>
                            <p>{perfil.email}</p>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-sm-6">
                    <div className="pt-4">
                        <h5>Tutor/es <button className="btn btn-success btn-sm" onClick={()=>setMostrarFormulario(true)}>+ Tutor</button></h5>
                        { mostrarFormulafio && <TutorCrudForm idEstudiante={perfil.id} mostrarFormulafio={mostrarFormulafio} setMostrarFormulario={setMostrarFormulario} /> }
                        {tutores.length > 0? tutores.map((tutor) => (
                            <div key={tutor.id} className="mb-2 alert alert-info p-2">
                                <div>
                                    <h6>
                                        <strong>{tutor.nombre} {tutor.apellido} </strong>
                                        <button className="btn btn-sm btn-warning" onClick={()=>setMostrarFormulario(true)}><i className="fas fa-pen"></i></button>
                                    </h6>
                                </div>
                                {tutor.email && (<div><i className="fa-regular fa-envelope text-secondary"></i> {tutor.email}</div>)}
                                {tutor.telefono && (<div><strong><i className="fa-solid fa-mobile-screen text-secondary"></i></strong> {tutor.telefono}</div>)}
                                {tutor.calle && (<div><small><strong><i className="fa-solid fa-location-dot"></i></strong> {tutor.calle} N°{tutor.numero} dpto:{tutor.depto} piso:{tutor.piso} ({tutor.ciudad}-{tutor.provincia})</small></div>)}
                            </div>
                        ))
                        : <div className="mt-2 mb-2 alert alert-warning p-2">Sin datos de tutores</div>
                        }
                    </div>
                </div>
            </div>
        </div>


            {/*solo para la vista general */}  
            {vista==='general' &&    
            <div className="row">
                <div className="sol-12 col-sm-4">
                    <div className='card-info-fija'>
                        <h5>Datos personales {rol<3 && <button className={`btn ${mostrarEditar?'btn-sm btn-secondary':''}`}  onClick={() => setMostrarEditar(!mostrarEditar)}>{mostrarEditar ?'':<i className="fa-solid fa-user-pen"></i>} {mostrarEditar ? `cancelar edición` : ``}</button>}</h5>
                        {!mostrarEditar &&
                            <PerfilInfo perfil={perfil} />
                        }
                        {mostrarEditar && 
                            <PerfilForm perfil={perfil} actualizarData={actualizarData} previewFoto={previewFoto}/>
                        }                
                    </div>
                </div>
                
                <div className="col-12 col-sm-8 mt-2">
                    <h5>Roles del usaurio</h5>
                    {roles.length > 0 ? (
                        <ul className="nav nav-tabs">
                            {roles.map((rol, index) => (
                                <li key={index} className="nav-item">
                                    <a
                                        className={`nav-link ${rol.id === activeIndex ? 'active' : ''}`}
                                        onClick={() => setActiveIndex(rol.id)}
                                        href="#"
                                    >
                                       <i className={rol.icono}></i> {rol.nombre}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <div className="mt-4">Sin roles</div>
                    )}
                    <div className="contenedor-tab ms-2">
                       {activeIndex === 1 && <h5 className="mt-3">Administrador Principal</h5>}
                        {activeIndex === 2 && <h5 className="mt-3">Administrador de datos</h5>}
                        {activeIndex === 3 && <h5 className="mt-3">Equipo directivo de la institución</h5>}
                        {activeIndex === 4 && <h5 className="mt-3">Secretario/a de la institución</h5>}

                        {activeIndex > 4 && (
                            <FichaUsuarioRolInfo rol={activeIndex} usuarioId={usuarioId} />
                        )}                  
                    </div>
                </div>
            </div>
            }
    </div>
    );
}

export default FichaUsuario;
